import { useState, useCallback } from "react"
import { generateApiKey, updateApiKey, deleteApiKey } from "../../services/api"
import translationEN from "../../../translations/integrations/translationEN.json"
import translationDE from "../../../translations/integrations/translationDE.json"

export const usePublicApiKeys = ({
  api_settings,
  current_user
}) => {
  const t = current_user.locale === "en" ? translationEN : translationDE;

  const [wait, setWait] = useState(false);
  const [apiKeys, setApiKeys] = useState(api_settings);
  
  const update = useCallback(
    async (id, data) => {
      setWait(true);
      const response = await updateApiKey(id, data);
      setWait(false);
      if (response.status === 200) {
        setApiKeys(old => old.map(i => i.id == id ? { id, ...data } : i));
        return { success: true };
      }
      const json = await response.json();
      return { error: json.error }
    },
    [setApiKeys, setWait]
  );

  const destroy = useCallback(
    async id => {
      setWait(true);
      const response = await deleteApiKey(id);
      setWait(false);
      if (response.status === 200) {
        setApiKeys(old => old.filter(i => i.id != id))
        return { success: true };
      }
    },
    [setApiKeys, setWait]
  );

  const generate = useCallback(
    async data => {
      setWait(true);
      const response = await generateApiKey(data);
      setWait(false);
      const json = await response.json();
      if (response.status === 201) {
        setApiKeys(old => [...old, json]);
        return { success: true }
      } else {
        return { error: json.error }
      }
    },
    [setApiKeys, setWait]
  );

  return { apiKeys, t, wait, update, destroy, generate };
}
